import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { reducers } from './store/index';
import { SubscriptionsRoutingModule } from './subscriptions.routing.module';
import { SubscriptionsLogicComponent } from './subscriptions-logic.component';
import { SubscriptionsComponent } from './subscriptions.component';

import { SubscriptionEffects } from './store/subscriptions.effects';
import { SubscriptionsService } from './subscriptions.service';
import { SharedModule } from './shared.module';
export class SubscriptionsModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SubscriptionsLogicComponent,
    SubscriptionsComponent,
 ],
  imports: [
    CommonModule,
    SubscriptionsRoutingModule,
    StoreModule.forFeature('subscriptions', reducers, {}),
    EffectsModule.forFeature([SubscriptionEffects]),
    SharedModule,

  ],
  exports: [
    SubscriptionsLogicComponent
  ],
  providers: [SubscriptionsService],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SubscriptionsModule_tsickle_Closure_declarations() {
/** @type {?} */
SubscriptionsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SubscriptionsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
